export const ROLES = {
  BROADCASTER: "broadcaster",
  HLS_VIEWER: "viewer", // hls-viewer
  VIEWER: "viewer",
  PRESENTER: "presenter",
  PANELIST: "panelist",
  TRANSLATOR: "translator",
  E_V: "e-v",
  F_V: "f-v",
  VIETNAMESE: "vietnamese",
  HOST: "host",
  CABIN: "cabin",
  GUEST: "guest",
  GUEST_ADVANCED: "guest-advanced",
};

export const ROLES_CONVERT = {
  presenter: "lbl_presenter",
  broadcaster: "lbl_broadcaster",
  panelist: "lbl_panelist",
  translator: "lbl_translator",
  "e-v": "lbl_e-v",
  "f-v": "lbl_f-v",
  vietnamese: "lbl_vietnamese",
  guest: "lbl_guest",
  "guest-advanced": "lbl_guest-advanced",
  viewer: "lbl_viewer",
  "hls-viewer": "lbl_hls-viewer",
};
